import { LoadableBackground } from '@confluence/loadable';

// Loadable-wrapped export — consistent with other experiment packages
export const CollaborationBriefPanel = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CollaborationBriefPanel" */ './CollaborationBriefPanel.tsx'
			)
		).CollaborationBriefPanel,
});
